import { getApis } from 'library/Apis';
import { toRequest } from 'utils/RequestUtils';
import { Dispatch } from 'redux';
import moment from 'moment';
import SnackbarUtils from 'utils/SnackbarUtils';
import languageValues from 'utils/LanguageUtils';
import { AdendoAditivo, AdendoDistrato, CreateValueEntePrivado, EditValueEntePrivado } from './__types';
import { AxiosError, AxiosResponse } from 'axios';

export const SET_CONTRATO_ID_ENTE_PRIVADO_ACTION = 'SET_CONTRATO_ID_ENTE_PRIVADO_ACTION';
export const CHANGED_CONTRATO_ENTE_PRIVADO_EDITING_VALUE_ACTION = 'CHANGED_CONTRATO_ENTE_PRIVADO_EDITING_VALUE_ACTION';
export const CLEAR_COD_COOP_ENTE_PRIVADO_ACTION = 'CLEAR_COD_COOP_ENTE_PRIVADO_ACTION';
export const CLEARED_CONTRATO_ENTE_PRIVADO_ACTION = 'CLEARED_CONTRATO_ENTE_PRIVADO_ACTION';
export const LOADED_CONTRATO_ENTE_PRIVADO_ACTION = 'LOADED_CONTRATO_ENTE_PRIVADO_ACTION';
export const LOADED_ADENDO_ENTE_PRIVADO_ACTION = 'LOADED_ADENDO_ENTE_PRIVADO_ACTION';
export const LOADED_CONTRATO_ENTE_PRIVADO_STATUS_GLOBAL_ACTION = 'LOADED_CONTRATO_ENTE_PRIVADO_STATUS_GLOBAL_ACTION'
export const LIST_ADENDOS_ENTE_PRIVADO_ACTION = 'LIST_ADENDOS_ENTE_PRIVADO_ACTION'
export const CLEAR_CONTRATO_ENTE_PRIVADO_STATUS_GLOBAL_ACTION = 'CLEAR_CONTRATO_ENTE_PRIVADO_STATUS_GLOBAL_ACTION'
export const OPEN_MODAL_ENTE_PRIVADO_ADITIVO_ACTION = 'OPEN_MODAL_ENTE_PRIVADO_ADITIVO_ACTION'
export const OPEN_MODAL_ENTE_PRIVADO_DISTRATO_ACTION = 'OPEN_MODAL_ENTE_PRIVADO_DISTRATO_ACTION'
export const CLOSE_MODAL_ENTE_PRIVADO_ADITIVO_ACTION = 'CLOSE_MODAL_ENTE_PRIVADO_ADITIVO_ACTION'
export const CLOSE_MODAL_ENTE_PRIVADO_DISTRATO_ACTION = 'CLOSE_MODAL_ENTE_PRIVADO_DISTRATO_ACTION'

export const setContratoEntePrivadoId = (id: number) => ({
  type: SET_CONTRATO_ID_ENTE_PRIVADO_ACTION,
  payload: id,
});

export const clearCodCoopEntePrivadoGenericForm = () => ({
  type: CLEAR_COD_COOP_ENTE_PRIVADO_ACTION,
  payload: null,
});

export const clearContratoEntePrivadoEditing = () => {
  return {
    type: CLEARED_CONTRATO_ENTE_PRIVADO_ACTION,
    payload: null,
  };
};

export const clearContratoStatusGlobal = () => {
  return {
    type: CLEAR_CONTRATO_ENTE_PRIVADO_STATUS_GLOBAL_ACTION,
  };
};

export const openModalEntePrivadoAditivo = () => ({
  type: OPEN_MODAL_ENTE_PRIVADO_ADITIVO_ACTION,
});

export const closeModalEntePrivadoAditivo = () => ({
  type: CLOSE_MODAL_ENTE_PRIVADO_ADITIVO_ACTION,
});

export const openModalEntePrivadoDistrato = () => ({
  type: OPEN_MODAL_ENTE_PRIVADO_DISTRATO_ACTION,
});

export const closeModalEntePrivadoDistrato = () => ({
  type: CLOSE_MODAL_ENTE_PRIVADO_DISTRATO_ACTION,
});

const getEndpoint = (version: number) => {
  return getApis().apis.contrato + 'v' + version;
};

export const changeContratoEntePrivadoEditingValue = (name: string, value: string) => {
  let payloadValue = value;

  if (typeof value === 'string') {
    payloadValue = value.trim().length > 0 ? value : '';
  }

  return {
    type: CHANGED_CONTRATO_ENTE_PRIVADO_EDITING_VALUE_ACTION,
    payload: { name, value: payloadValue },
  };
};

export const contratoEntePrivadoDescentralizadoRegisterPreEtapa = async (
  preEtapa: CreateValueEntePrivado,
  dispatch: Dispatch
) => {
  const valoresPreEtapaFormatados = {
    ...preEtapa,
    dataInicio: moment(preEtapa.dataInicio, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    dataFim: moment(preEtapa.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD'),
  };
  const resp = await toRequest('post', [
    `${getEndpoint(1)}/contrato/ente-privado/descentralizado`,
    valoresPreEtapaFormatados,
  ]);
  dispatch(setContratoEntePrivadoId(resp.data.id));
  return resp;
};

export const loadContratoEntePrivado = (
  id: number | null,
  versaoContrato: number
) => {
  return async (dispatch: Dispatch) => {
    try {
      const contratoResponse = await toRequest('get', [
        `${getEndpoint(
          1
        )}/contrato/ente-privado/descentralizado/${id}/${versaoContrato}`,
      ]);
      const contratoData = {
        ...contratoResponse.data,
        dataInicio: contratoResponse.data.dataInicio
          ? moment(contratoResponse.data.dataInicio, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
          : '',
        dataFim: contratoResponse.data.dataFim
          ? moment(contratoResponse.data.dataFim, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
          : '',
        dataDistrato: contratoResponse.data.dataDistrato
          ? moment(contratoResponse.data.dataDistrato, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
          : '',
      };
      dispatch({
        type: LOADED_CONTRATO_ENTE_PRIVADO_ACTION,
        payload: contratoData,
      });
    } catch (error) {
      SnackbarUtils.enqueueSnackbar({
        message:
          error ||
          languageValues.toasts.error.carregarContratosEntePrivadoDescentralizado,
        options: {
          variant: 'error',
        },
      });
    }
  };
};

export const loadContratoEntePrivadoAdendos = (id: number | null) => {
  return async (dispatch: Dispatch) => {
    try {
      const adendosResponse = await toRequest('get', [
        `${getEndpoint(1)}/contrato/listar-adendos/${id}`,
      ]);
      dispatch({
        type: LOADED_ADENDO_ENTE_PRIVADO_ACTION,
        payload: adendosResponse.data,
      });
      dispatch({
        type: LOADED_CONTRATO_ENTE_PRIVADO_STATUS_GLOBAL_ACTION,
        payload: adendosResponse.data.flgStatus,
      });
      dispatch({
        type: LIST_ADENDOS_ENTE_PRIVADO_ACTION,
        payload: { adendos: adendosResponse.data.adendos || [] },
      });
    } catch (error) {
      SnackbarUtils.enqueueSnackbar({
        message:
          error ||
          languageValues.toasts.error
            .carregarContratosEntePrivadoDescentralizadosAdendos,
        options: {
          variant: 'error',
        },
      });
    }
  };
};

export const contratoEntePrivadoDescentralizadoEdit = async (
  idContrato: number,
  preEtapaEdit: EditValueEntePrivado,
  dispatch: Dispatch
) => {
  const valoresPreEtapaEditFormatados = {
    ...preEtapaEdit,
    dataInicio: moment(preEtapaEdit.dataInicio, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    dataFim: moment(preEtapaEdit.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD')
  }
  const resp = await toRequest('put', [
    `${getEndpoint(1)}/contrato/ente-privado/descentralizado/${idContrato}`,
    valoresPreEtapaEditFormatados,
  ]);
  dispatch(setContratoEntePrivadoId(resp.data.id));
  return resp;
};

export const contratoEntePrivadoDescentralizadoEditAditivo = (
  idAditivo: number | null,
  aditivo: AdendoAditivo,
  callbackSuccess: (response: AxiosResponse) => void,
  callbackError: (error: AxiosError) => void
) => {
  return async () => {
    try {
      const resp = await toRequest('put', [
        `${getEndpoint(
          1
        )}/contrato/ente-privado/descentralizado/aditivo/${idAditivo}`,
        aditivo,
      ]);
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(resp);
      }
    } catch (error) {
      if (typeof callbackError === 'function') {
        callbackError(error as AxiosError);
      }
    }
  };
};

export const contratoEntePrivadoDescentralizadoCreateAditivo = (
  aditivo: AdendoAditivo,
  callbackSuccess: (response: AxiosResponse) => void,
  callbackError: (error: AxiosError) => void
) => {
  return async () => {
    try {
      const resp = await toRequest('post', [
        `${getEndpoint(1)}/contrato/ente-privado/descentralizado/aditivo`,
        aditivo,
      ]);
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(resp);
      }
    } catch (error) {
      if (typeof callbackError === 'function') {
        callbackError(error as AxiosError);
      }
    }
  };
};

export const contratoEntePrivadoDescentralizadoEditDistrato = (
  idDistrato: number | null,
  distrato: AdendoDistrato,
  callbackSuccess: (response: AxiosResponse) => void,
  callbackError: (error: AxiosError) => void
) => {
  return async () => {
    try {
      const resp = await toRequest('put', [
        `${getEndpoint(
          1
        )}/contrato/ente-privado/descentralizado/distrato/${idDistrato}`,
        distrato,
      ]);
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(resp);
      }
    } catch (error) {
      if (typeof callbackError === 'function') {
        callbackError(error as AxiosError);
      }
    }
  };
};

export const contratoEntePrivadoDescentralizadoCreateDistrato = (
  distrato: AdendoDistrato, callbackSuccess: (response: AxiosResponse) => void,
  callbackError: (error: AxiosError) => void
) => {
  return async () => {
    try {
      const resp = await toRequest('post', [
        `${getEndpoint(1)}/contrato/ente-privado/descentralizado/distrato`,
        distrato,
      ]);
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(resp);
      }
    } catch (error) {
      if (typeof callbackError === 'function') {
        callbackError(error as AxiosError);
      }
    }
  };
};